import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './UniversalHeader.css';
import SearchResults from '../SearchResults/SearchResults';
import Logo from '../Logo/Logo'; // Import the new Logo component

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const UniversalHeader = ({ onMenuClick }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [liveSearchResults, setLiveSearchResults] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchSearchData = async () => {
      try {
        const [eventsResponse, countriesResponse] = await Promise.all([
          fetch(`${API_URL}/events`),
          fetch(`${API_URL}/countries`)
        ]);
        const eventsData = await eventsResponse.json();
        const countriesData = await countriesResponse.json();
        setAllEvents(eventsData);
        setAvailableCountries(countriesData);
      } catch (error) {
        console.error("Failed to fetch search data:", error);
      }
    };
    fetchSearchData();
  }, []);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (!term.trim()) {
      setLiveSearchResults([]);
      return;
    }
    const lowercasedTerm = term.toLowerCase();
    
    const eventResults = allEvents
      .filter(event => 
        event.title.toLowerCase().includes(lowercasedTerm) ||
        (event.country && event.country.toLowerCase().includes(lowercasedTerm))
      )
      .map(event => ({ ...event, type: 'event' }));

    const countrySuggestions = availableCountries
      .filter(country => country.name.toLowerCase().includes(lowercasedTerm))
      .map(country => ({
        id: `filter-country-${country.name}`,
        type: 'filter',
        value: country.name,
        display: `Filter by country: ${country.name}`
      }));

    const combinedResults = [...countrySuggestions];
    const eventIds = new Set();
    eventResults.forEach(event => {
        if (!eventIds.has(event.id)) {
            combinedResults.push(event);
            eventIds.add(event.id);
        }
    });

    setLiveSearchResults(combinedResults);
  };
  
  const handleResultClick = () => {
      setSearchTerm('');
      setLiveSearchResults([]);
  };

  const handleFilterResultClick = (countryName) => {
    const currentCountries = searchParams.getAll('country');
    
    if (!currentCountries.includes(countryName)) {
      const newCountries = [...currentCountries, countryName];
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('country');
      newCountries.forEach(c => newSearchParams.append('country', c));
      navigate(`/?${newSearchParams.toString()}`);
    }
    handleResultClick();
  };

  return (
    <header className="universal-header">
      <div className="header-left">
        <button className="hamburger-button" onClick={onMenuClick} aria-label="Toggle Menu">
          <div className="hamburger-bar" />
          <div className="hamburger-bar" />
          <div className="hamburger-bar" />
        </button>
        {/* --- THIS IS THE CHANGE --- */}
        <Logo />
        {/* ------------------------- */}
      </div>
      <div className="header-center">
        <div className="search-wrapper-header">
          <input
            type="text"
            placeholder="Search events or countries..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {searchTerm && liveSearchResults.length > 0 &&
            <SearchResults
              results={liveSearchResults}
              onEventResultClick={handleResultClick}
              onFilterResultClick={handleFilterResultClick}
            />
          }
        </div>
      </div>
      <div className="header-right" />
    </header>
  );
};

export default UniversalHeader;
